import { EventNames } from '@farmasiet/frontendcore-reactcomponents';
import * as React from 'react';

import { getTranslation, keys } from '../../../../Resources/Translations';

export const LogoutFromBankIdMenuSection = () => {
    const logout = () => window.dispatchEvent(new CustomEvent(EventNames.RxLogoutRequest));

    return (
        <div className="LogoutFromBankIdMenuSection">
            <div className="LogoutFromBankIdMenuSection__Divider" />
            <button className="LogoutFromBankIdMenuSection__Button" onClick={logout}>
                {getTranslation(keys['actionMenu.logOutFromBankId'])}
            </button>
        </div>
    );
};
